export const pageFacility = {
    // ロード完了したとき
    loadDone: function (results) {
        $(".js-ajax").html(results["template"]);
        $(".js-content").hide().fadeIn(300);

        // 保存ボタンが押されたときの挙動。
        $(".js-submit").unbind();
        $(".js-submit").click(function () {
            form.disableButtons(this);

            $(".nursery__side-menu-content").data("editing", "false");
            window.removeEventListener("beforeunload", nursery.saveAlert);
            const url = $("#basicForm").attr("action");
            form.post(url, "#basicForm", "更新が完了しました", () => {
                pageFacility.postDone();
                form.activateButtons(this);
            });
        });

        // フォームに変更があった際、離脱時にアラートを表示
        $("form").change(function () {
            $(".nursery__side-menu-content").data("editing", "true");
            window.addEventListener("beforeunload", nursery.saveAlert);
        });
    },
    // POST完了
    postDone: function (results) {
        $("#js-nav-pagetop").trigger("click");
    }
};
